import { render, staticRenderFns } from "./TagSvg.vue?vue&type=template&id=80ef4760"
import script from "./TagSvg.vue?vue&type=script&lang=js"
export * from "./TagSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports